/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 11/5/2022 上午 10:19 下午 1:57 🚌🚄🚈🚝 */
<template>
	<div class="step-wrap" ref="stepWrap">
		<div class="step-btn" @click="changeVal('+')">+</div>
		<div class="step-val">{{ Math.floor(val * 100) / 100 }}</div>
		<div class="step-btn" @click="changeVal('-')">-</div>
	</div>
</template>

<script>
export default {
	name: 'temp',
	props: {
		defaultVal: {
			type: [String, Number],
			default: '0'
		},
		step: {
			type: Number,
			default: 1
		},
		isFilterZero: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			val: 0,
			time: ''
		}
	},
	created() {
		this.val = +this.defaultVal
	},
	mounted() {
		this.$refs['stepWrap'].onmousewheel = event => {
			const down = event.wheelDelta ? event.wheelDelta < 0 : event.detail > 0
			if (down) {
				if (this.isFilterZero) {
					const curVal = this.val - this.step
					this.val = curVal <= 0 ? 0 : curVal
				} else {
					this.val -= this.step
				}
			} else {
				this.val += this.step
			}
			this.$emit('stepVal', this.val)
		}
	},
	methods: {
		changeVal(type) {
			if (type === '+') {
				this.val += this.step
			} else {
				this.val -= this.step
			}
			this.$emit('stepVal', this.val)
		}
	}
}
</script>

<style scoped lang="less">
.step-wrap {
	width: 160px;
	height: 40px;
	display: flex;
	align-items: center;
	overflow: hidden;
	border: 1px solid #eeeeee;
	border-radius: 25px;
	.step-btn {
		width: 40px;
		text-align: center;
		font-size: 25px;
		&:hover {
			cursor: pointer;
		}
	}
	.step-val {
		width: 80px;
		text-align: center;
		line-height: 30px;
		border-left: 1px solid #ebebeb;
		border-right: 1px solid #ebebeb;
	}
}
</style>
